import React, { Component } from "react";
import ItemAdderPanelView from "presentational/upload/ItemAdderPanelView";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";

class ItemAdderPanel extends Component {
  static propTypes = {
    mode: PropTypes.oneOf(["outfitUpload", "outfitEdit"]).isRequired,
    stickeredImageDataURL: PropTypes.string.isRequired,
    selectedItemList: PropTypes.array.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    onItemUploadBtnClick: PropTypes.func.isRequired,
    onItemSelect: PropTypes.func.isRequired
  };

  async initList() {
    const { MyItemActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      MyItemActions.removeExportedList();
      await MyItemActions.initItemList(idToken);
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  }

  async getChangedItemList(category) {
    const { MyItemActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyItemActions.changeItemList({ category, idToken });
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  }

  handleDropdownSelect = async (key, category) => {
    await this.getChangedItemList(category);
  };

  HandleNextItemListRequest = async () => {
    const { MyItemActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await MyItemActions.getList(idToken);
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
    }
  };

  handleBackBtnClick = () => {
    const { onBackClick } = this.props;
    onBackClick();
  };

  handleNextBtnClick = () => {
    const { onNextClick } = this.props;
    onNextClick();
  };

  handleSelectedListChange = selectedItemList => {
    const { onItemSelect } = this.props;
    onItemSelect(selectedItemList);
  };

  render() {
    const {
      stickeredImageDataURL,
      selectedItemList,
      onItemUploadBtnClick,
      mode,
      catListOfMine,
      itemList,
      nowCategory,
      isLoading,
      isEnd
    } = this.props;

    return (
      <ItemAdderPanelView
        stickeredImageDataURL={stickeredImageDataURL}
        selectedItemList={selectedItemList}
        onItemUploadBtnClick={onItemUploadBtnClick}
        onSelectListChange={this.handleSelectedListChange}
        onBackBtnClick={this.handleBackBtnClick}
        mode={mode}
        onNextBtnClick={this.handleNextBtnClick}
        catListOfMine={catListOfMine}
        selectedCategory={nowCategory}
        selectableItemList={itemList}
        isLoading={isLoading}
        isEnd={isEnd}
        onDropdownSelect={this.handleDropdownSelect}
        onNextItemListRequest={this.HandleNextItemListRequest}
      />
    );
  }

  componentDidMount() {
    this.initList();
  }
}

export default withToken(
  withStore({
    stateMap: {
      myItem: ["itemList", "nowCategory", "isLoading", "catListOfMine", "isEnd"]
    },
    dispatchMap: ["myItem", "appError"]
  })(ItemAdderPanel)
);
